if (!customElements.get('pack-pro')) {
    customElements.define(
      'pack-pro',
      class ComplementaryProductSlider extends HTMLElement {
        constructor() {
          super();

          let _items;

          if(window.innerWidth > 768){
            _items = '5';
          }else{
            _items = '3';
          }
  
          this.sliderOptions = {
            slidesPerView: _items,
            spaceBetween: 10,
            loop: false,
            grabCursor: false,
            allowTouchMove: true,
            autoHeight: true,
            navigation: {
              prevEl: this.querySelector('.swiper-button-prev'),
              nextEl: this.querySelector('.swiper-button-next'),
            },
            pagination: false,
          };
        }


  
        connectedCallback() {
          const slider = this.querySelector('.swiper');
          this.sliderInstance = new window.FoxTheme.Carousel(slider, this.sliderOptions);

          this.sliderInstance.init();
        }

      }
    );
  }
  


  if (!customElements.get('pack-main')) {
    customElements.define(
      'pack-main',
      class ComplementaryProductSlider extends HTMLElement {
        constructor() {
          super();

          let _items;

          if(window.innerWidth > 768){
            _items = '1.5';
          }else{
            _items = '1';
          }
  
          this.sliderOptions = {
            slidesPerView: _items,
            spaceBetween: 10,
            loop: false,
            grabCursor: false,
            allowTouchMove: true,
            autoHeight: true,
            navigation: {
              prevEl: this.querySelector('.swiper-button-prev'),
              nextEl: this.querySelector('.swiper-button-next'),
            },
            pagination: false,
          };
        }

        
  
        connectedCallback() {
          const slider = this.querySelector('.swiper');
          this.sliderInstance = new window.FoxTheme.Carousel(slider, this.sliderOptions);

          this.sliderInstance.init();
        }

      }
    );
  }
  